import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NbButtonModule, NbCardModule, NbIconModule } from '@nebular/theme';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ExportCsvComponent } from './export-csv/export-csv.component';
import { ImportCsvComponent } from './import-csv/import-csv.component';
import { IssueLoaderComponent } from './issue-loader/issue-loader.component';
import { ModalCofirmacaoComponent } from './modal-confirmacao/modal-confirmacao.component';
import { ModalComprovanteDespesaComponent } from '../../pages/gestao-plano-viagem/plano-viagens/modal-comprovante-despesa/modal-comprovante-despesa.component';
import { ChatbotButtonComponent } from './chatbot-button/chatbot-button.component';
import { MensagemAlertaComponent } from './mensagem-alerta/mensagem-alerta.component';

@NgModule({
  imports: [
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NgxDatatableModule,
    ContentLoaderModule,
    CommonModule,
  ],
  exports: [
    ExportCsvComponent,
    ImportCsvComponent,
    IssueLoaderComponent,
    ModalCofirmacaoComponent,
    ChatbotButtonComponent,
    MensagemAlertaComponent,
  ],
  declarations: [
    ExportCsvComponent,
    ImportCsvComponent,
    IssueLoaderComponent,
    ModalCofirmacaoComponent,
    ModalComprovanteDespesaComponent,
    ChatbotButtonComponent,
    MensagemAlertaComponent,
  ],
  entryComponents: [
    ModalComprovanteDespesaComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentstModule { }
